import { DEFAULT_DESCRIPTION } from './constants'

export function parseMsgInfo(msgInfo) {
  if (msgInfo == null || msgInfo === '') return null
  if (typeof msgInfo === 'object') return msgInfo
  const raw = String(msgInfo).trim()
  if (!raw.startsWith('{') && !raw.startsWith('[')) return null
  try {
    return JSON.parse(raw)
  } catch {
    return null
  }
}

function stripHtml(text) {
  return String(text)
    .replace(/<[^>]+>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&[a-z]+;/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim()
}

export function extractDescription({ msgAbs, describe, msgInfo } = {}, fallback = DEFAULT_DESCRIPTION) {
  if (msgAbs) {
    const value = stripHtml(msgAbs)
    if (value && !value.startsWith('{')) return truncate(value)
  }

  const parsed = parseMsgInfo(msgInfo)
  if (parsed?.describe) {
    const value = stripHtml(parsed.describe)
    if (value) return truncate(value)
  }

  if (describe) {
    const value = stripHtml(describe)
    if (value) return truncate(value)
  }

  if (typeof msgInfo === 'string' && !msgInfo.trim().startsWith('{')) {
    const value = stripHtml(msgInfo)
    if (value) return truncate(value)
  }

  return fallback
}

export function extractImage(item = {}) {
  const parsed = parseMsgInfo(item.msgInfo)
  if (parsed?.avatar) return parsed.avatar
  if (parsed?.pic) return String(parsed.pic).split(',')[0].trim()
  if (item.avatar) return item.avatar
  if (item.pic) return String(item.pic).split(',')[0].trim()
  if (typeof item.msgInfo === 'string') {
    const match = item.msgInfo.match(/<img[^>]+src=["']([^"']+)["']/i)
    if (match) return match[1]
  }
  return ''
}

function truncate(text) {
  if (text.length > 160) return `${text.slice(0, 157)}...`
  return text
}

export function canonicalPath(fullPath = '/') {
  const [pathname] = String(fullPath).split('?')
  const clean = pathname.replace(/\/+$/, '') || '/'
  return clean === '/' ? '/' : `${clean}/`
}

export function masterHighQualityCategoryPath(msgType, name) {
  return `/masterHighQuality/${msgType}/${encodeURIComponent(String(name))}`
}
